define('editor/render/index',['durandal/app', 'plugins/router', 'plugins/http', 'plugins/dialog', 'knockout', 'knockout-mapping', 'jquery'], function (app, router, http, dialog, ko, komapping, $) {
    var viewmodel = function () {
        var self = this;

        self.router = router;
        self.editorMapId = null;
        self.editorMap = null;
        self.map = ko.observable();
        self.height = ko.observable(0);
        self.width = ko.observable(0);
        self.layers = ko.observableArray([]);

        self.activate = function (editorMapId) {
            self.editorMapId = editorMapId;

            self.fetchEditorMap(self.editorMapId)
                .then(self.initialiseChildModules);

            self.registerEventHandlers();
        };

        self.registerEventHandlers = function() {
            app.on("map:ready", self.fetchLayers);
        };

        self.fetchEditorMap = function (id) {
            var url = "/api/editor/edit/" + id;

            if (self.router.activeInstruction() && self.router.activeInstruction().queryString) {
                url += '?' + self.router.activeInstruction().queryString;
            }
            
            return http.get(url)
                .then(function (response) {
                    if (response.data) {
                        self.editorMap = response.data.editorMap;
                        self.height(self.editorMap.height);
                        self.width(self.editorMap.width);
                    } else {
                        app.showError(response, "Unexpected Error", "Unable to retrieve map");
                    }
                }).fail(app.showError);
        };

        self.fetchLayers = function() {
            var layersUrl = "/api/editor/layers",
                data = {
                    editorMapId: self.editorMapId
                };
            
            if (self.router.activeInstruction() && self.router.activeInstruction().queryString) {
                layersUrl += '?' + self.router.activeInstruction().queryString;
            }

            return http.get(layersUrl, data)
                .then(function(response) {
                    if (response.data) {
                        self.layers.removeAll();

                        // manually map layer properties to get knockout computeds to work
                        var layers = [];

                        for (var i = 0; i < response.data.layers.length; i++) {
                            var layerData = response.data.layers[i];
                            var layer = self.makeLayer(layerData);
                            layers.push(layer);
                        }

                        ko.utils.arrayPushAll(self.layers, layers);

                        // we're done, publish the original layer data so other things can do something with it
                        app.trigger('layers:newData', self.layers); 
                    }
                }).fail(app.showError);
        };

        self.makeLayer = function(data) {
            var layer = {};
            if (data.state.html) {
                data.state.html = String(data.state.html);
            }

            var state = data.state;

            if (data.type !== 'Directions') {
                state = komapping.fromJS(data.state);
                delete state['__ko_mapping__'];
            }

            layer.id = ko.observable(data.id);
            layer.groupId = ko.observable(data.groupId);
            layer.groupName = ko.observable(data.groupName);
            layer.groupColour = ko.observable(data.groupColour);
            layer.groupCollapsed = ko.observable(data.groupCollapsed);
            layer.name = ko.observable(data.name);
            layer.visible = ko.observable(data.visible);
            layer.type = ko.observable(data.type);
            layer.order = ko.observable(data.order);
            layer.state = ko.observable(state);
            //layer.typeIcon = this.makeIcon(data);
            layer.isGroup = ko.observable(false);
            layer.labelOrName = ko.observable(data.state && data.state.html && data.state.html.length > 0 ? data.state.html : data.name);

            return layer;
        };

        self.initialiseChildModules = function () {
            self.map({ model: 'editor/edit/map/index', activationData: [self.editorMap, true] });
        };

        self.cancelEvent = function (viewModel, event) {
            // stop mouse interactions changing the state of map layers
            event.stopPropagation();
            return false;
        };
    };

    return viewmodel;
});

